import { Link } from "react-router-dom";
import type { ModuleKey } from "@gaole/shared";
import { useAuth } from "../../stores/auth";

const CARDS: { to: string; label: string; image: string; module: ModuleKey }[] = [
  { to: "/raffles", label: "Raffles", image: "/raffle.png", module: "raffles" },
  { to: "/inventory", label: "FlexxiPlan", image: "/instalment.png", module: "instalments" },
  { to: "/shop", label: "Shop", image: "/shop.png", module: "ecommerce" },
  { to: "/auctions", label: "Auctions", image: "/auction.png", module: "auctions" },
];

function CategoryCard({
  to,
  label,
  image,
  enabled,
}: {
  to: string;
  label: string;
  image: string;
  enabled: boolean;
}) {
  const inner = (
    <>
      <span
        className="pointer-events-none absolute inset-0 opacity-60 transition-opacity lg:group-hover:opacity-90"
        style={{
          background: "radial-gradient(circle at 50% 35%, rgba(221,84,235,0.22), transparent 65%)",
        }}
        aria-hidden
      />
      {!enabled && (
        <span className="absolute right-2 top-2 z-10 rounded-full bg-white/10 px-2 py-0.5 text-[9px] font-bold uppercase tracking-wide text-white/70 backdrop-blur-sm">
          Coming soon
        </span>
      )}
      <img
        src={image}
        alt=""
        className="relative h-16 w-16 object-contain drop-shadow-[0_6px_18px_rgba(221,84,235,0.35)] transition-transform lg:group-hover:scale-110 sm:h-20 sm:w-20"
        draggable={false}
      />
      <span className="relative font-display text-xs font-bold uppercase tracking-wide text-white">{label}</span>
    </>
  );

  const className = `group relative flex flex-col items-center gap-1 overflow-hidden rounded-2xl border border-white/10 bg-surface px-3 py-4 transition-all ${
    enabled
      ? "active:scale-[0.97] lg:hover:-translate-y-1 lg:hover:border-brand-pink/40 lg:hover:glow-brand"
      : "pointer-events-none opacity-50"
  }`;

  if (enabled) {
    return (
      <Link to={to} className={className}>
        {inner}
      </Link>
    );
  }

  return <div className={className}>{inner}</div>;
}

/**
 * Storefront destination cards — disabled modules stay visible with a
 * "Coming soon" badge until an admin turns them on.
 */
export function CategoryCardGrid() {
  const { moduleEnabled } = useAuth();

  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
      {CARDS.map((card) => (
        <CategoryCard
          key={card.to}
          to={card.to}
          label={card.label}
          image={card.image}
          enabled={moduleEnabled(card.module)}
        />
      ))}
    </div>
  );
}
